export default {
  getSystem: "/apppositionrelation/query/{positionId}",
  getPermission: "/menu/userpermission",
  getPermissionType: "/permissionclass/query/{code}",
  getPermissionData: "/positiondataauthority/positiondatapermission",
  setMenusPermission:"/menu/addusermenu",
  setDataPermission:"/positiondataauthority/insert",
  setAppPermission:"/apppositionrelation/insert",
  setOrganPermission:"/positiondataauthority/batchsave",
  syncPost:"/position/setpositionauthority",
  syncPost2:"/positiondataauthority/pasteauthority",
}



// WEBPACK FOOTER //
// ./src/api/config/permission.js